import { QueryClient } from '@tanstack/react-query';
import { theme } from '@conviva/vision-antd';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export const antdModifiedTheme = {
  token: {
    ...theme.vision.token,
  },
};

export const logger = console;
